export default __webpack_public_path__ + "assets/icons/txt.51344a4b.svg";